export default __webpack_public_path__ + "static/media/i232hk.1cf64688.webp";